import React, { useState, useRef } from 'react';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable'; // Import the plugin for jsPDF
import IconButton from '../../elements/IconButton';
import Button from '../../elements/Button';

const Main = (props) => {
    const [loadedData, setLoadedData] = useState([]);
    const [stillGettingData, setStillGettingData] = useState(0);
    const isCancelled = useRef(false); // Used to track if fetching was cancelled

    const handleCancelFetch = () => {
        isCancelled.current = true; // Set flag to true when fetching is cancelled
    };

    const fetchAllData = (exportType) => {
        let skip = 0;
        const limit = 1;
        let allData = [];
        setStillGettingData(1);

        const fetchNext = () => {
            if (isCancelled.current) {
                console.log("Fetching has been cancelled by the user.");
                setStillGettingData(0); // Update state to reflect cancellation
                return;
            }
            getData(skip, limit, (hasMoreData, newData) => {
                if (newData[0].subagent_ID !== null) {
                    allData = allData.concat(newData);
                    skip += limit;
                    fetchNext();
                } else {
                    if (exportType === 'CSV') {
                        downloadCSV(allData, props.exportKeys, props.fileTitle);
                    } else if (exportType === 'PDF') {
                        downloadPDF(allData, props.exportKeys, props.fileTitle);
                    }
                    setStillGettingData(2);
                }
            });
        };

        fetchNext();
    };

    const getData = (skip, limit, onCompletion) => {
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(props.filterData)
        };

        props.tokenSafeAPIRequest(
            `${props.url}${props.specific ? '/' + props.specific : ''}?limit=${limit}&fetch_links=true&skip=${skip}&sort_field=${props.sort}&start_date=${props.calStartDate}&end_date=${props.calEndDate}&active_only=false`,
            requestOptions,
            '',
            (result, status) => {
                if ('postProcessing' in props) {
                    result = props.postProcessing(result);
                }

                console.log(result)

                if ('reports' in result) {
                    processResult(result.reports, onCompletion);
                } else if ('accounts' in result) {
                    processResult(result.accounts, onCompletion);
                } else if ('transactions' in result) {
                    processResult(result.transactions, onCompletion);
                } else if ('dealerships' in result) {
                    processResult(result.dealerships, onCompletion);
                } else if ('spiffs' in result) {
                    processResult(result.spiffs, onCompletion);
                } else if ('dppps_and_gap' in result) {
                    processResult(result.dppps_and_gap, onCompletion);
                } else {
                    processResult(result, onCompletion);
                }
            }
        );
    };

    const processResult = (data, onCompletion) => {
        if (data && data.length > 0) {
            setLoadedData((loadedData) => [...loadedData, ...data]);
            onCompletion(true, data);
        } else {
            onCompletion(false);
        }
    };

    function formatNumber(value) {
        try {
            // Attempt to convert the input to a number
            const num = parseFloat(value);
            // Check if the conversion resulted in a valid number
            if (!isNaN(num)) {
              // Use Intl.NumberFormat for US-style number formatting with two decimal places
              return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(num);
            } else {
              // Return a default value if the input is not a valid number
              return '0.00';
            }
          } catch (e) {
            // In case of any unexpected errors, return a default value
            return '0.00';
          }
    }

    const downloadCSV = (data, keys, filename = 'data.csv') => {
        console.log(keys)
        console.log(data)

        let csvContent = "";

        let dpppTableTotal = 0;
        let gapTableTotal = 0;

        data.sort((a, b) => a.subagent_name.localeCompare(b.subagent_name));

        data.map((agent) => {
            if (agent.dppps.length === 0)
            {

            }
            else
            {
                let agentTotal = 0;
                csvContent += `${agent.subagent_name}\n`;
                csvContent += "\r\n";

                csvContent += "DPPP\r\n";
                csvContent += "Agent,Dealer,Contract Type,Admin,Amount per contract,QTY,Total\r\n";
                agent.dppps.forEach((dppp) => {
                    csvContent += `${agent.subagent_name},${dppp.dealership_ID.name},${dppp.contract_type + ' - ' + dppp.contract_subtype},${dppp.admin_ID.name},${dppp.DPPP},${dppp.quantity},${dppp.quantity * dppp.DPPP}\r\n`;
                    agentTotal = agentTotal + (dppp.quantity * dppp.DPPP)
                    dpppTableTotal = dpppTableTotal + (dppp.quantity * dppp.DPPP)
                })
                csvContent += `Total Agent GAP DPPP: $${agentTotal}\r\n`;
                csvContent += "\r\n";
            }
        })
        csvContent += `Total GAP DPPP: $${dpppTableTotal}\r\n`;
        csvContent += "\r\n";
        csvContent += "\r\n";

        data.map((agent) => {
            if (agent.gaps.length === 0)
            {

            }
            else
            {
                let agentTotal = 0;
                csvContent += `${agent.subagent_name}\n`;
                csvContent += "\r\n";

                csvContent += "GAP Plus\r\n";
                csvContent += "Agent,Dealer,Contract Type,Admin,Amount per contract,QTY,Total\r\n";
                agent.gaps.forEach((gap) => {
                    csvContent += `${agent.subagent_name},${gap.dealership_ID.name},${gap.contract_type + ' - ' + gap.contract_subtype},${gap.admin_ID.name},${gap.GAP},${gap.quantity},${gap.quantity * gap.GAP}\r\n`;
                    agentTotal = agentTotal + (gap.quantity * gap.GAP)
                    gapTableTotal = gapTableTotal + (gap.quantity * gap.GAP)
                })
                csvContent += `Total Agent GAP PLUS: $${agentTotal}\r\n`;
                csvContent += "\r\n";
            }
        })
        csvContent += `Total GAP PLUS: $${gapTableTotal}\r\n`;
    
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    };
    
    const downloadPDF = (data, keys, filename = 'data.pdf') => {
        console.log(data)
        const doc = new jsPDF({orientation: 'landscape'});
    
        // Add title
        doc.text(props.fileTitle || 'Report', 20, 10);

        let pageCount = 1;

        const addPageNumbers = (doc) => {
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height;
            const pageWidth = pageSize.width;
    
            // Add footer with page number
            const pageCount = doc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.text(
                    `Page ${i}`,
                    pageWidth - 30,
                    pageHeight - 10
                );
            }
        };

        const gapTableData = [];
        const dpppTableData = []

        let gapTableTotal = 0;
        let dpppTableTotal = 0;

        data.sort((a, b) => a.subagent_name.localeCompare(b.subagent_name));

        data.map((agent) => {
            console.log(agent)
            let agentDPPPTotal = 0;
            let agentGAPTotal = 0;
            agent.dppps.forEach((dppp) => {
                agentDPPPTotal = agentDPPPTotal + (dppp.quantity * dppp.DPPP)
                dpppTableTotal = dpppTableTotal + (dppp.quantity * dppp.DPPP)
                dpppTableData.push([
                    agent.subagent_name,
                    dppp.dealership_ID.name,
                    dppp.contract_type + ' - ' + dppp.contract_subtype,
                    dppp.admin_ID.name,
                    '$' + dppp.DPPP,
                    dppp.quantity,
                    '$' + formatNumber(dppp.quantity * dppp.DPPP)
                ])
            })
            if (agentDPPPTotal !== 0) {
                dpppTableData.push(['Total','','','','','','$' + formatNumber(agentDPPPTotal)])
                dpppTableData.push({
                    isAgentEnd: true,
                    data: [
                        {content: '', colSpan: 7, styles: { fillColor: [255,255,255], minCellHeight: 0.1, cellPadding: 0 } }
                    ],
                })
            }
            agent.gaps.forEach((gap) => {
                agentGAPTotal = agentGAPTotal + (gap.quantity * gap.GAP)
                gapTableTotal = gapTableTotal + (gap.quantity * gap.GAP)
                gapTableData.push([
                    agent.subagent_name,
                    gap.dealership_ID.name,
                    gap.contract_type + ' - ' + gap.contract_subtype,
                    gap.admin_ID.name,
                    '$' + gap.GAP,
                    gap.quantity,
                    '$' + formatNumber(gap.quantity * gap.GAP)
                ])
            })
            if (agentGAPTotal !== 0) {
                gapTableData.push(['Total','','','','','','$' + formatNumber(agentGAPTotal)])
                gapTableData.push({
                    isAgentEnd: true,
                    data: [
                        {content: '', colSpan: 7, styles: { fillColor: [255,255,255], minCellHeight: 0.1, cellPadding: 0 } }
                    ],
                })
            }
        })

        doc.text(`DPPP - Total: $` + formatNumber(dpppTableTotal), 14, 27.5);
    
        // Add Summary table with light grey border and no row fill color
        doc.autoTable({
            startY: 32.5,
            head: [['Agent', 'Dealer', 'Contract Type', 'Admin', 'Amount Per Contract', 'Quantity', 'Total']],
            body: dpppTableData,
            styles: {
                lineColor: [200, 200, 200], // Light grey border lines
                lineWidth: 0.1             // Thin border lines
            },
            bodyStyles: {
                fillColor: false             // Disable row fill color completely
            },
            headStyles: {
                fillColor: false,            // No background for header row
                textColor: 0,                // Black text
                lineColor: [200, 200, 200],  // Light grey border lines for header
                lineWidth: 0.1
            },
            tableLineColor: [200, 200, 200], // Light grey border around table
            tableLineWidth: 0.1,
            didParseCell: function (data) {
                if (data.row.raw && data.row.raw[0] === 'Total') {
                    data.cell.styles.fontStyle = 'bold';
                    data.cell.styles.textColor = [0, 0, 0];
                    data.cell.styles.fontSize = 11;
                }
            },
            willDrawCell: function(data) {
                const rowInfo = dpppTableData[data.row.index];
                if (rowInfo?.isAgentEnd) {
                    data.cell.styles.lineWidth = { top: 0.1, right: 0.1, bottom: 2.0, left: 0.1 };
                    data.cell.styles.lineColor = { bottom: [255,255,255] };
                }
            }
        });

        doc.text(`GAP PLUS - Total: $` + formatNumber(gapTableTotal), 14, doc.lastAutoTable.finalY + 10);
    
        // Add Summary table with light grey border and no row fill color
        doc.autoTable({
            startY: doc.lastAutoTable.finalY + 30,
            head: [['Agent', 'Dealer', 'Contract Type', 'Admin', 'Amount Per Contract', 'Quantity', 'Total']],
            body: gapTableData,
            styles: {
                lineColor: [200, 200, 200], // Light grey border lines
                lineWidth: 0.1             // Thin border lines
            },
            bodyStyles: {
                fillColor: false             // Disable row fill color completely
            },
            headStyles: {
                fillColor: false,            // No background for header row
                textColor: 0,                // Black text
                lineColor: [200, 200, 200],  // Light grey border lines for header
                lineWidth: 0.1
            },
            tableLineColor: [200, 200, 200], // Light grey border around table
            tableLineWidth: 0.1,
            didParseCell: function (data) {
                if (data.row.raw && data.row.raw[0] === 'Total') {
                    data.cell.styles.fontStyle = 'bold';
                    data.cell.styles.textColor = [0, 0, 0];
                    data.cell.styles.fontSize = 11;
                }
            },
            willDrawCell: function(data) {
                const rowInfo = gapTableData[data.row.index];
                if (rowInfo?.isAgentEnd) {
                    data.cell.styles.lineWidth = { top: 0.1, right: 0.1, bottom: 2.0, left: 0.1 };
                    data.cell.styles.lineColor = { bottom: [255,255,255] };
                }
            }
        });

        pageCount++;


        addPageNumbers(doc);
    
        // Save the PDF
        doc.save(filename);
    };
    

    return (
        <div style={{ width: '360px', height: 'auto', display: 'flex', flexDirection: 'column' }}>
            <div style={{ flexBasis: '10%', display: 'flex', flexDirection: 'row' }}>
                <span style={{ fontWeight: '500', fontSize: '20px', flexBasis: '99%' }}>Export Report</span>
                <IconButton img={false} colors={props.colors} Style={{ borderRadius: '3px', backgroundColor: props.colors.border, width: '24px' }} size="16px">
                    <div onClick={() => { handleCancelFetch(); props.setIsOpen() }} style={{ paddingLeft: '3px', paddingRight: '3px' }}><span onClick={() => { handleCancelFetch(); props.setIsOpen() }}>x</span></div>
                </IconButton>
            </div>
            <div style={{ flexBasis: '90%', display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                <span style={{ fontWeight: '500', fontSize: '16px' }}>Downloaded Rows: {loadedData.length}</span>
                <Button colors={props.colors} active={true} Style={{ marginTop: '10px' }} onClick={() => fetchAllData('CSV')}>Download CSV</Button>
                <Button colors={props.colors} active={true} Style={{ marginTop: '10px' }} onClick={() => fetchAllData('PDF')}>Download PDF</Button>
            </div>
        </div>
    );
};

export default Main;
